import { useBillingApi } from '../../../../hooks/useApi/useBillingApi/useBillingApi'
import { InvoiceDetails } from '../../components/InvoiceDetails/InvoiceDetails'

type InvoiceDetailsContainerProps = {
    invoiceId: string
}

export const InvoiceDetailsContainer: React.FC<InvoiceDetailsContainerProps> = (
    props
) => {
    const { invoiceId } = props
    const { useGetInvoice } = useBillingApi()
    const { data, isLoading, isFetched, isFetching } = useGetInvoice(invoiceId)

    const loading = !isFetched || isFetching || isLoading

    return (
        <InvoiceDetails
            invoice={data ?? { invoiceNo: invoiceId }}
            loading={loading}
        />
    )
}
